import CheckCircle from "@mui/icons-material/CheckCircle";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";
import { useEffect } from "react";

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  language: SupportedLanguage;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onClose,
  language,
}) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // Closes the dialog after 3 seconds

      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
          bgcolor: "#fff",
        },
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            mb: 3,
          }}
        >
          <img
            src="/pimo-large.svg"
            alt={getLocalizedMessage(
              language,
              "auth.registration.successDialog.logoAlt"
            )}
            style={{ height: 60, marginRight: 8 }}
          />
        </Box>

        <Box sx={{ mb: 3 }}>
          <CheckCircle
            sx={{
              fontSize: 80,
              color: "#4caf50",
            }}
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "#222",
            mb: 2,
          }}
        >
          {getLocalizedMessage(
            language,
            "auth.registration.successDialog.title"
          )}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#666",
            lineHeight: 1.6,
          }}
        >
          {getLocalizedMessage(
            language,
            "auth.registration.successDialog.description"
          )}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
